// d88a0b5e33a0fc9e3ecff4452e7a717a9acf33cd|kind=parser-js|name=ChatContext|schemaHash=a9798b67fb5d155914bee8793879d12ded7845d7

import { setDefinedValue } from '@myre/common-primitives';

import { parseChatContextParamsFromJSON, parseChatContextParamsToJSON } from './ChatContextParams';

export function parseChatContextFromJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(
    result,
    'params',
    parseChatContextParamsFromJSON(
      _data.params
    ),
  );
  setDefinedValue(result, 'url', _data.url);
  setDefinedValue(result, 'moduleNames', _data.moduleNames);
  setDefinedValue(result, 'queryParams', _data.queryParams);

  return result;
}

export function parseChatContextToJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(
    result,
    'params',
    parseChatContextParamsToJSON(
      _data.params
    ),
  );
  setDefinedValue(result, 'url', _data.url);
  setDefinedValue(result, 'moduleNames', _data.moduleNames);
  setDefinedValue(result, 'queryParams', _data.queryParams);

  return result;
}
